import { graphql, Link, navigate } from 'gatsby'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useRef, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import profileApi from '../../services/ProfileAPI'
import { getStoredUser } from '../../services/auth'
import * as styles from './index.module.css'
import { Helmet } from 'react-helmet'

function SignUp(props) {

  const { contentfulAsset } = props.data

  const [base64Image, setBase64Image] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (file) {
      setSelectedFileName(file.name); // Update selected file name

      // Convert file to base64 string
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setBase64Image(reader.result); // Set base64 string in state
      };
    }
  };

  // ref
  const userNameValue = useRef(null);
  const emailValue = useRef(null);
  const passValue = useRef(null);
  const confirmPassword = useRef(null);
  const fullNameValue = useRef(null);
  const addressValue = useRef(null);
  const occupationValue = useRef(null);
  const phoneNumberValue = useRef(null);
  const dateOfBirthValue = useRef(null);

  useEffect(() => {
    if (getStoredUser()?.accessToken) navigate('/');
  }, [])
  const handleSignUp = (e) => {
    e.preventDefault();
    if (
      !userNameValue.current?.value ||
      !emailValue.current?.value ||
      !passValue.current?.value ||
      !confirmPassword.current?.value ||
      !fullNameValue.current?.value ||
      !addressValue.current?.value ||
      !occupationValue.current?.value ||
      !phoneNumberValue.current?.value ||
      !dateOfBirthValue.current?.value ||
      !base64Image // Ensure an image is selected
    ) {
      alert("Please fill in all the required fields, including the image.");
      return;
    }


    if (passValue.current?.value !== confirmPassword.current?.value) {
      alert("Passwords do not match.");
      return;
    }
    const signUpDetails = {
      username: userNameValue.current?.value.toString(),
      email: emailValue.current?.value.toString(),
      password: passValue.current?.value.toString(),
      fullName: fullNameValue.current?.value.toString(),
      address: addressValue.current?.value.toString(),
      occupation: occupationValue.current?.value.toString(),
      phoneNumber: phoneNumberValue.current?.value.toString(),
      dateOfBirth: dateOfBirthValue.current?.value.toString(),
      driverLicenseLink: base64Image
    };
    setLoading(true);
    profileApi.userSignUp(signUpDetails)
      .then(res => {
        setLoading(false);
        alert(res.data.message);
        navigate('/login');
      })
      .catch(err => {
        setLoading(false);
        alert(err.response?.data?.message || err.message || 'Unable to create account. Please try again.');
      });
  };
  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Signup - Loack&Load</title>
      </Helmet>
      <div className={styles.signup}>

        <div className={styles.top}>
          <div className={styles.logo}>
            <GatsbyImage image={contentfulAsset.gatsbyImageData} alt={contentfulAsset.title} />
          </div>
          <h1 style={{ margin: '0px' }}>Load and Lock</h1>
          <p style={{ color: '#2C4169', textAlign: 'center', margin: '0px' }}>Already have an account? <Link to='/login'>Sign In</Link></p>
        </div>


        <div className={styles.uploadFile}>
          <p style={{ textAlign: 'center', padding: '0px 15px' }}>Please upload an image of your driver's license</p>
          <div className={styles.uploadIcon}>
            <StaticImage src='../../assets/Images/uploadFileIcon.png' alt='Upload File Icon' />
          </div>


          {selectedFileName && <p style={{ textAlign: 'center', marginTop: '10px' }}>{selectedFileName}</p>}

          <label className={styles.uploadBtn} htmlFor='uploadFile'>Save File</label>
          <input id='uploadFile' type='file' hidden onChange={handleFileChange} />
        </div>
        <div className={styles.form}>
          <div className={styles.formItems}>
            <label>Username</label>
            <input type='text' name='username' ref={userNameValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Full Name</label>
            <input type='text' name='fullName' ref={fullNameValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Address</label>
            <input type='text' name='address' ref={addressValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Date of Birth</label>
            <input type='date' name='dateOfBirth' ref={dateOfBirthValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Phone Number</label>
            <input type='tel' name='phoneNumber' ref={phoneNumberValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Occupation</label>
            <input type='text' name='occupation' ref={occupationValue} required />
          </div>

          <div className={styles.formItems}>
            <label>Email Address</label>
            <input type='email' name='email' ref={emailValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Password</label>
            <input type='password' name='password' ref={passValue} required />
          </div>
          <div className={styles.formItems}>
            <label>Confirm Password</label>
            <input type='password' ref={confirmPassword} required />
          </div>
        </div>
        {
          loading ?
            <p className={styles.signUpBtn}>Loading...</p>
            :
            <p className={styles.signUpBtn} onClick={handleSignUp} role='none'>Sign Up</p>
        }
      </div>
    </Layout>
  )
}

export default SignUp

export const pageQuery = graphql`
query SignupPageQuery {
  contentfulAsset(title: {eq: "Logo"}) {
    gatsbyImageData(placeholder: TRACED_SVG)
    title
  }
}

`
